import Alpine from 'alpinejs'
import { initFormieForms } from './formie.js'

// CSS
import "./styles.css";

// Define moohApp function before Alpine starts
window.moohApp = function() {
    return {
        mobileMenuOpen: false,
        mobileDropdown: null
    }
}

Alpine.data('downloadHelper', () => ({
    forceDownload(url) {
        if (new URL(url, location.href).hostname === location.hostname) {
            const a = Object.assign(document.createElement('a'), { href: url, download: '' });
            a.click();
            return;
        }
        fetch(url)
            .then(r => {
                if (!r.ok) throw new Error('Download failed: ' + r.status);
                return r.blob();
            })
            .then(blob => {
                const a = Object.assign(document.createElement('a'), {
                    href: URL.createObjectURL(blob),
                    download: '',
                });
                a.click();
                URL.revokeObjectURL(a.href);
            })
            .catch(() => window.open(url));
    }
}));


// Initialize Alpine.js
window.Alpine = Alpine
Alpine.start()

initFormieForms()

// Import any additional JavaScript modules here
// Example: import './components/mobile-menu.js'
